export default "__VITE_ASSET__mCDQ_Ney__"